/* global Adcurve, $ */
Adcurve.onLoad(function(){
  $('#example-file-toggle').on('click', function(){
    $('#example-file').toggle();

  });
});
